'use client'

import type { Provider } from '@patrianna/shared-patrianna-types/store/ProviderModule'
import cx from 'classnames'
import Link from 'next/link'
import { useParams } from 'next/navigation'
import { useState } from 'react'

import { providerCodeTransform } from 'app/(pages)/providers/utils/providersNaming'
import GameRowHeader from 'src/components/GameRowHeader'
import HorizontalScroll from 'src/containers/HorizontalScroll'
import slotsClasses from 'src/pageContainers/Home/components/SlotsRow/styles.module.scss'
import { useThemeContext } from 'theme/themeProvider'

import classes from './styles.module.scss'

type Props = {
  products: Provider[]
  title: string
  url?: string
  iconImg?: string
  isProvidersPage?: boolean
}

export default function Providers(props: Props) {
  const { products, isProvidersPage, ...headerProps } = props

  const { isDarkMode } = useThemeContext()
  const params = useParams()

  const [activeProvider, setActiveProvider] = useState<string>((params.providerName as string)?.replace('%20', ' '))

  if (products?.length) {
    return (
      <>
        <GameRowHeader isProviders={isProvidersPage} {...headerProps} />
        <HorizontalScroll
          data-test={`${props.title}-games-row`}
          className={classes.container}
          classNameContainer={cx(
            slotsClasses.root,
            slotsClasses.slotsContainerRoot,
            isProvidersPage && classes.isProviders,
          )}
          linesAmount={1}
          styleContainer={{
            gridTemplateRows: 'repeat(1, auto)',
          }}
          selectedIndex={products.findIndex((product) => activeProvider === product.code)}
          autoScrollToSpace={16}
          isScrollSmooth={false}
        >
          {products.map((product) => {
            const providerCode = providerCodeTransform(product.code)
            const isSelected = activeProvider === product.code

            return (
              <Link href={`/providers/${product.code}`} key={`${product.code}-link`}>
                <li
                  className={cx(classes.listItem, isSelected && classes.isActive, isDarkMode && classes.isDarkMode)}
                  key={product.code}
                  onClick={() => {
                    if (isProvidersPage && activeProvider !== product.code) {
                      setActiveProvider(product.code)
                    }
                  }}
                >
                  <img
                    src={`${process.env.IMG_ORIGIN}/game-providers/${providerCode}.png`}
                    // alt={adjustAltTag(product.code)}
                    className={cx(classes.img, isSelected && classes.activeProviderImg)}
                    loading='lazy'
                    alt=''
                  />
                </li>
              </Link>
            )
          })}
        </HorizontalScroll>
      </>
    )
  }

  return null
}
